import { FileItem } from "@/components/features/matter/file-repo/FileItem";
import { useDrag } from "react-dnd";
import { type RepoItem } from "./FileRepository";

export type DraggableItemProps = {
  item: RepoItem;
  isSelected: boolean;
  onSelect: () => void;
  onDelete?: () => void;
  selectedIndex?: number;
  disabled?: boolean;
  onAddToShareFolder?: () => void;
  shareFolderLabel?: string;
  dataTestId?: string;
};

export function DraggableItem(props: DraggableItemProps) {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: "FILE_SYSTEM_ITEM",
    item: props.item,
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  return <FileItem drag={drag} isDragging={isDragging} {...props} />;
}
